import { Tabs } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import File from '../../interfaces/File';
import FileDetailActivitiesTab from './FileDetailActivitiesTab';
import TruncatedTooltip from '../Common/TruncatedTooltip';
import FileDetailTab from './FileDetailTab';
import { useAuth } from '../../hooks/useAuth';

interface FileDetailProps {
  file: File;
}

const FileDetail: React.FC<FileDetailProps> = ({ file }) => {
  const { t } = useTranslation();
  const { isAdminOrContributor } = useAuth();

  return (
    <div className="file-detail-side relative flex h-full flex-col px-2">
      <h2 className="max-w-72 shrink-0 truncate text-xl font-medium">
        <TruncatedTooltip>{file.title}</TruncatedTooltip>
      </h2>
      <Tabs
        defaultActiveKey="1"
        centered
        className="file-detail-side h-full overflow-y-auto"
        items={[
          {
            key: '1',
            label: t('common.details'),
            children: <FileDetailTab file={file} />,
          },
          {
            disabled: !isAdminOrContributor,
            key: '2',
            label: t('common.activities'),
            children: <FileDetailActivitiesTab file={file} />,
          },
        ]}
      />
    </div>
  );
};

export default FileDetail;
